module.exports = __webpack_public_path__ + "img/impact-in-action-mobile@3x.f61a15fe.webp";